<i18n>
{
	"en": {
		"PleaseInputToSearch": "Please input to search"
	},
	"vi": {
		"PleaseInputToSearch": "Gõ tên đối tượng để tìm kiếm."
	}
}
</i18n>

<template>
	<div>
		<!-- Block tag employee, departement, title -->
		<div class="container-watcher--block-item">
			<h6 v-if="title" class="mb-2 custom-component--title">{{ title }}<span class="text-danger" v-if="isRequired">&nbsp;*</span>:</h6>
			<v-select
				:ref="ref"
				label="name"
				v-bind="$attrs"
				v-on="$listeners"
				:filterable="false"
				:multiple="multiple"
				:options="humanRoles"
				:placeholder="placeholder"
				@search="fetchOptions"
				class="bg-white select-multiple"
				:closeOnSelect="true"
				:getOptionKey="option => ref + option.id + option.type"
			>
				<template #option="{ value, name, type }">
					<div>
						<cbs-relation-icon :type="type" />
						{{ name || value }}
					</div>
				</template>
				<template #selected-option="{ value, type, name}">
					<cbs-relation-icon :type="type" />
					<p>{{ name || value }}</p>
				</template>
				<template #no-options>
					{{ noOptionsTitle ? noOptionsTitle : $t("PleaseInputToSearch") }}
				</template>
			</v-select>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";

import * as _ from "lodash";
import AlarmGql from "@/http/requests/cbs/alarm_gql.js";

export default {
	inheritAttrs: false,
	name: "AlarmRelations",
	props: {
		title: {
			type: String
		},
		placeholder: {
			type: String
		},

		multiple: {
			type: Boolean,
			default: true
		},
		noOptionsTitle: {
			type: String
		},
		isRequired: {
			type: Boolean
		},

		model: String,
		addingOptions: {
			type: Array,
			default: () => []
		}
	},
	components: {
		"v-select": vSelect
	},
	watch: {
		model() {
			this.fetchRoles();
		}
	},
	data() {
		return {
			humanRoles: [...this.addingOptions],
			relations: null,
			ref: _.uniqueId("alarmRelations_")
		};
	},
	methods: {
		fetchOptions(search, loading) {
			clearTimeout(this.timer);
			this.timer = setTimeout(async () => {
				if (!loading) {
					loading = this.$refs[this.ref] && this.$refs[this.ref].toggleLoading;
				}

				loading(true);
				try {
					await this.fetchRoles(search);
					loading(false);
				} catch (error) {
					loading(false);
				}
			}, 400);
		},
		async fetchRoles(search = "") {
			const response = await AlarmGql.getAlarmApplyObject({ search: search, model: this.model });
			if (response && response.objects) {
				const humanRoles = response.objects || [];
				this.humanRoles = [...this.addingOptions, ...humanRoles];
			}
		}
	}
};
</script>
<style lang="scss">
.container-watcher--block-item {
	.vs__selected {
		.inline-block {
			line-height: 100%;
		}
		.nucleo {
			color: var(--color-white);
		}
	}
}
</style>
